const PermissionTypes={
    READ:"READ",
    WRITE:"WRITE",
    DELETE:"DELETE"
}

export default PermissionTypes;